/**
 * Feature flags utilities
 */

export const FeatureFlags = {
  /** Rejestracja (logowanie Google + strona sign-up). Przełączana z konsoli przez `window.hotelspot`. */
  REGISTER_FLOW: 'REGISTER_FLOW',
} as const;

/** Nazwa istniejącej flagi — chroni przed literówką w kluczu localStorage. */
export type FeatureFlag = typeof FeatureFlags[keyof typeof FeatureFlags];

/**
 * Check if a feature flag is enabled
 * @param flag - The feature flag name
 * @returns true if the flag is enabled (set to 'true'), false otherwise
 */
export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  try {
    const value = localStorage.getItem(flag);
    return value === 'true' || value === 'TRUE';
  } catch {
    return false;
  }
};

/**
 * Set a feature flag value
 * @param flag - The feature flag name
 * @param enabled - Whether the flag should be enabled
 */
export const setFeatureFlag = (flag: FeatureFlag, enabled: boolean): void => {
  try {
    localStorage.setItem(flag, enabled ? 'true' : 'false');
  } catch {
    // Ignore localStorage errors
  }
};
